import React from 'react';
import { Text } from '@chakra-ui/react';
import ModalShell from '../../../../components/ui/ModalShell';
import { ff } from '../../../../theme';

interface CancelChangesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const CancelChangesModal: React.FC<CancelChangesModalProps> = ({ isOpen, onClose, onConfirm }) => (
  <ModalShell
    isOpen={isOpen}
    onClose={onClose}
    title="Discard changes?"
    cancelLabel="Keep editing"
    primary={{ label: 'Discard', onClick: onConfirm, tone: 'danger' }}
  >
    <Text color={ff.text2}>All changes will be discarded.</Text>
  </ModalShell>
);

export default CancelChangesModal;
